export default __webpack_public_path__ + "static/5-5090cc6e3188eb0c5ef96524504b0367.png";